import React from "react";
import { FaqModule } from "../../carlsberg-headless/types/modules/Faq";
import { Helmet } from "react-helmet";

export type FAQProps = FaqModule;

const FAQ: React.FC<FAQProps> = ({ question, answer }) => {
  if (!question || !answer) return null;

  return (
    <Helmet>
      <script type="application/ld+json">
        {`
          {
            "@context": "https://schema.org",
            "@type": "QAPage",
            "mainEntity": {
              "@type": "Question",
              "name": "${question}",
              "text": "${question}",
              "answerCount": 1,
              "author": {
                "@type": "Organization",
                "name": "Carlsberg"
              },
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "${answer}",
                "author": {
                  "@type": "Organization",
                  "name": "Carlsberg"
                }
              }
            }
          }
        `}
      </script>
    </Helmet>
  );
};

export { FAQ };
